import { analytics, ContextualUpsellEvents } from '@/lib/analytics'

interface ContextualUpsellOpenedEventData {
  upsell: string
  source: string | null
  userRole: 'Administrator' | 'User'
  isManaged: boolean
  currentPlan: string
}

interface ContextualUpsellClosedEventData {
  upsell: string
  converted: boolean
  durationMs: number
}

interface ContextualUpsellConvertedEventData {
  upsell: string
  currentPlan: string
  userRole: 'Administrator' | 'User'
}

export function trackContextualUpsellOpened(
  data: ContextualUpsellOpenedEventData,
): void {
  analytics.track(ContextualUpsellEvents.OPENED, {
    upsell: data.upsell,
    source: data.source,
    user_role: data.userRole,
    is_managed: data.isManaged,
    current_plan: data.currentPlan,
  })
}

export function trackContextualUpsellClosed(
  data: ContextualUpsellClosedEventData,
): void {
  analytics.track(ContextualUpsellEvents.CLOSED, {
    upsell: data.upsell,
    converted: data.converted,
    duration_ms: data.durationMs,
  })
}

export function trackContextualUpsellConverted(
  data: ContextualUpsellConvertedEventData,
): void {
  analytics.track(ContextualUpsellEvents.CONVERTED, {
    upsell: data.upsell,
    current_plan: data.currentPlan,
    user_role: data.userRole,
  })
}
